export default "__VITE_ASSET__86104488__"